import Card from './Card.wrapper';
import { ICardProps } from './Card.interfaces';

export default Card;
export { Card, ICardProps };
